import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS} from "../shared/colors";
import {FontManager} from "../shared/fonts";

const fontManager = FontManager.getInstance();

fontManager.registerFont("Instrument_Serif", {
  style: {
    fontFamily: "Instrument Serif",
  }
});

fontManager.registerFont("Inter", {
  style: {
    fontFamily: "Inter",
  }
});

fontManager.registerFont("DM_Serif_Display", {
  style: {
    fontFamily: "DM Serif Display",
  }
});

fontManager.registerFont("DM_Sans", {
  style: {
    fontFamily: "DM Sans",
  }
});

fontManager.registerFont("Josefin_Sans", {
  style: {
    fontFamily: "Josefin Sans",
  }
});

fontManager.registerFont("Raleway", {
  style: {
    fontFamily: "Raleway",
  }
});

fontManager.registerFont("Urbanist", {
  style: {
    fontFamily: "Urbanist",
  }
});

fontManager.registerFont("Outfit", {
  style: {
    fontFamily: "Outfit",
  }
});

export const COLOR_PRIMARY = "#000066";
export const COLOR_SECONDARY = "#ff6600";

const HEADING_FONT = "Plus Jakarta Sans, sans-serif";
const BODY_FONT = "Inter, sans-serif";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  typography: {
    ...DEFAULT_THEME_OPTIONS.typography,
    h1: {
      fontWeight: "bold",
      letterSpacing: -1.3,
      fontFamily: HEADING_FONT,
    },
    h2: {
      fontWeight: "bold",
      letterSpacing: -1.2,
      fontFamily: HEADING_FONT,
      fontSize: "440%",
    },
    h3: {
      fontWeight: "bold",
      letterSpacing: -1.1,
      fontFamily: HEADING_FONT,
    },
    h4: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    h5: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    h6: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    fontFamily: BODY_FONT,
    fontSize: 14,
  },
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#fff",
    },
  }
};

export const THEME = createTheme(THEME_OPTIONS);
